import { ClientTransMapping } from "../../../../utils/types/clientTransMapping.type";
import { TransactionColumn } from "../../../../utils/types/workbook.type";

export function applyMetricSigns(transactionColumns: TransactionColumn[], clientTransMapping: ClientTransMapping) {
    
    const transTypes = clientTransMapping.rows.filter(r => !r.useMetric);

    const clientTransTypeColumns = clientTransMapping.columns;
    const clientTransValueCol = clientTransTypeColumns.find(c => c.code === 'VALUE');
    const clientTransValueIndex = clientTransValueCol ? clientTransValueCol.index : 0;

    transactionColumns.forEach(col => {
        const mapRow = clientTransMapping.rows.find(row => row.id === col.transTypeId);
        const metricSign = mapRow?.values ? mapRow.values[clientTransValueIndex] : 0;

        col.metricSign = metricSign;
    });

    
}